import { Navigate, Outlet } from 'react-router-dom'
import { useAuthContext } from '../context/auth/auth'
import { navigateTo } from '../helpers/navigateTo'

const PublicRoute = () => {
  const { token, userType } = useAuthContext()

  // A token we cannot read a role out of is no better than no token: leave the
  // user on the public page rather than redirecting them somewhere blind.
  return token && userType ? (
    <Navigate to={navigateTo(userType)} replace />
  ) : (
    <Outlet />
  )
}

export default PublicRoute
